<ion-content [fullscreen]="true" class="signup-content">
  <app-kz-auth-shell class="auth-shell--wide">
    <!-- kz2 F1: the slot-based shell. Identity is projected, never passed as inputs (D12c). -->
    <app-kz-brand-lockup appbar [showStrapline]="false"></app-kz-brand-lockup>
    <app-kz-brand-lockup pitchTop [onPrimary]="true" [showStrapline]="false"></app-kz-brand-lockup>
    <div pitchLead>
      <p class="pitch__p">{{ $any(appEnv).appStatement | inlinetranslate }}</p>
    </div>

    <div class="auth-form">
      <header class="auth-form__head">
        <h1>{{ 'app.pages.signup.title' | translate }}</h1>
        <p>{{ 'app.pages.signup.subtitle' | translate }}</p>
      </header>

      <kz-dynamic-form
        [submitButtonText]="'app.pages.signup.action' | translate"
        submitButtonIcon="log-in"
        SubmitButtonExpandStyle="block"
        submitButtonFill="solid"
        submitButtonColor="primary"
        [model]="formModel"
        (submitted)="onSubmit($event)"
        [enableSubmitButton]="false"
      >
        <ion-text class="auth-form__terms terms-of-use">
          <p>
            {{ 'app.registration.termsOfUse' | translate }}
            <a (click)="showPrivacyModal()"><span class="link">{{ 'app.registration.termsOfUse1' | translate }}</span></a>
            {{ 'uiString.and' | translate }}
            <a class="legal-action" (click)="showTermsModal()"><span class="link">{{ 'app.registration.termsOfUse2' | translate }}</span></a>.
          </p>
        </ion-text>
      </kz-dynamic-form>

      @if (showSocialLogin) {
        <div class="auth-form__divider"><span>{{ 'app.registration.OrSignUpWith' | translate }}</span></div>
        <ion-grid class="auth-form__social-grid">
          <ion-row>
            <ion-col size="6">
              <ion-button expand="block" fill="outline" color="medium">
                <ion-icon slot="icon-only" name="logo-facebook"></ion-icon>
              </ion-button>
            </ion-col>
            <ion-col size="6">
              <ion-button expand="block" fill="outline" color="medium">
                <ion-icon slot="icon-only" name="logo-google"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      }

      <p class="auth-form__alt">
        {{ 'app.pages.login.haveAccount' | translate }}
        <a tappable (click)="goToLogin()">{{ 'uiString.login' | translate }}</a>
      </p>
    </div>
  </app-kz-auth-shell>
</ion-content>
